import type { InputHTMLAttributes, ReactNode } from "react";

type FieldProps = {
  label: string;
  htmlFor: string;
  hint?: ReactNode;
  children: ReactNode;
};

export function Field({ label, htmlFor, hint, children }: FieldProps) {
  return (
    <div className="flex flex-col gap-2">
      <label
        htmlFor={htmlFor}
        className="font-serif text-base italic text-[var(--color-forest-deep)]"
      >
        {label}
      </label>
      {children}
      {hint ? (
        <span className="text-xs text-[var(--color-muted)]">{hint}</span>
      ) : null}
    </div>
  );
}

type InputProps = InputHTMLAttributes<HTMLInputElement>;

export function Input({ className = "", ...props }: InputProps) {
  return (
    <input
      {...props}
      className={`w-full border-0 border-b border-[var(--color-rule)] bg-transparent px-1 py-3 font-serif text-xl text-[var(--color-charcoal)] placeholder:text-[var(--color-muted)]/70 focus:border-[var(--color-forest)] focus:outline-none ${className}`}
    />
  );
}
